module.exports = __webpack_public_path__ + "static/media/Toscana60x120-1.a86bf4d6.jpg";